import { DefaultService } from '@/services/DefaultService';


export default class AssFormaPagamentoClienteService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllVendas(column, order, page, limit, situacao, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/cliente/assformapagtocliente.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllAgro(column, order, page, limit, situacao, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/cliente/assformapagtocliente.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    find(id) {
		return this._http.get(`${this._env}/ven/cliente/assformapagtocliente/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacaoVendas(assformapagtocliente) {
        return this._http.post(`${this._env}/ven/cliente/assformapagtocliente/updatesituacao`, assformapagtocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(assformapagtocliente) {
        return this._http.post(`${this._env}/agro/cliente/assformapagtocliente/updatesituacao`, assformapagtocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociadosVendas(column, order, page, limit, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/cliente/assformapagtocliente/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${idcliente}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociadosAgro(column, order, page, limit, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/cliente/assformapagtocliente/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcliente=${idcliente}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveVendas(assformapagtocliente) {
        return this._http.post(`${this._env}/ven/cliente/assformapagtocliente`, assformapagtocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(assformapagtocliente) {
        return this._http.post(`${this._env}/agro/cliente/assformapagtocliente`, assformapagtocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAssVendas(assformapagtocliente) {
        return this._http.post(`${this._env}/ven/cliente/assformapagtocliente/save`, assformapagtocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAssAgro(assformapagtocliente) {
        return this._http.post(`${this._env}/agro/cliente/assformapagtocliente/save`, assformapagtocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}